import {Button, Stack} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';

import {clientsUnitsQuery, clientsUnitsService} from '@store/clients/units';
import {GlobalStatus} from '@store/common/globalStatus.enum';

import {Download} from '@icons/index';

import TabsComponent from '@components/tabs/Tabs.component';
import ClientsUnitsTable from '@screens/admin/clients/units/ClientsUnits.table';

const ClientsUnitsTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(clientsUnitsQuery.status$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsUnitsService.getClientsUnitsCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
      </Stack>
      <Stack flex={1} spacing={3}>
        <TabsComponent
          ariaLabel="secondary"
          handleChange={(value) => clientsUnitsService.setStatus(GlobalStatus.tabs[value])}
          value={GlobalStatus.tabs.indexOf(filterStatus ?? undefined)}
          tabs={[t('routes.all')]}/>
        <Stack flex={1}>
          <ClientsUnitsTable/>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ClientsUnitsTab;
